import React from "react";
import "./../styles/Dashboard.css";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import info from "../../info.json";

const activeTileStyles = {
  boxShadow: "rgb(258, 71, 11, 0.8) 0px 0px 10px 10px",
};
const activeTiles = info.MD_RESPONSE ? 5 : 4;
const boxRatio = activeTiles == 5 ? 2 : 2.5;
export const ClinicalDashboard = (props) => {
  return (
    <>
      {/* <Box className="cardbundle"> */}
      <Box
        className="cardbundle"
        style={{ maxWidth: "2160px", paddingTop: "3rem", marginBottom: "3rem" }}
      >
        <Grid container>
          {props.dashboardTasklist ? (
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={10}>
                <Grid item xl={1} lg={1} md={1} sm={1} xs={1}>
                  &nbsp;
                </Grid>
                <Grid
                  item
                  xl={boxRatio}
                  lg={boxRatio}
                  md={boxRatio}
                  sm={6}
                  xs={12}
                >
                  <Box
                    className="managerCard"
                    sx={{ cursor: "pointer", backgroundColor: "#F5F5F5" }}
                    onClick={props.handlePending}
                    style={props.activeStyle.pending ? activeTileStyles : {}}
                  >
                    <img src="img/pending.svg" width="50" height="70" />
                    <Typography variant="h5">
                      {props.dashboardTasklist.Pending}
                    </Typography>
                    <Typography
                      style={{ fontSize: "14px" }}
                      variant="h6"
                      sx={{
                        color: "#FB4E0B",
                        textTransform: "uppercase",
                      }}
                    >
                      Pending
                    </Typography>
                  </Box>
                  {/* {props.activeStyle.pending ? (
                    <img
                      src="img/polygon.svg"
                      width="50"
                      height="70"
                      style={{
                        alignContent: "center",
                        width: "100%",
                        padding: 20,
                      }}
                    />
                  ) : (
                    ""
                  )} */}
                </Grid>
                <Grid
                  item
                  xl={boxRatio}
                  lg={boxRatio}
                  md={boxRatio}
                  sm={6}
                  xs={12}
                >
                  <Box
                    className="managerCard"
                    sx={{ cursor: "pointer", backgroundColor: "#F5F5F5" }}
                    onClick={props.handleInprogress}
                    style={props.activeStyle.inprogress ? activeTileStyles : {}}
                  >
                    <img src="img/progress.svg" width="50" height="70" />
                    <Typography variant="h5">
                      {props.dashboardTasklist.InProgress}{" "}
                    </Typography>
                    <Typography
                      variant="h6"
                      style={{ fontSize: "14px" }}
                      sx={{
                        color: "#FB4E0B",
                        textTransform: "uppercase",
                      }}
                    >
                      In-Progress
                    </Typography>
                  </Box>
                  {/* {props.activeStyle.inprogress ? (
                    <img
                      src="img/polygon.svg"
                      width="50"
                      height="70"
                      style={{
                        alignContent: "center",
                        width: "100%",
                        padding: 20,
                      }}
                    />
                  ) : (
                    ""
                  )} */}
                </Grid>
                <Grid
                  item
                  xl={boxRatio}
                  lg={boxRatio}
                  md={boxRatio}
                  sm={6}
                  xs={12}
                >
                  <Box
                    className="managerCard"
                    sx={{ cursor: "pointer", backgroundColor: "#F5F5F5" }}
                    onClick={props.handleCompleted}
                    style={props.activeStyle.completed ? activeTileStyles : {}}
                  >
                    <img src="img/completed.svg" width="50" height="70" />
                    <Typography variant="h5">
                      {props.dashboardTasklist.Completed}{" "}
                    </Typography>
                    <Typography
                      variant="h6"
                      style={{ fontSize: "14px" }}
                      sx={{
                        color: "#FB4E0B",
                        textTransform: "uppercase",
                      }}
                    >
                      Completed
                    </Typography>
                  </Box>
                  {/* {props.activeStyle.completed ? (
                    <img
                      src="img/polygon.svg"
                      width="50"
                      height="70"
                      style={{
                        alignContent: "center",
                        width: "100%",
                        padding: 20,
                      }}
                    />
                  ) : (
                    ""
                  )} */}
                </Grid>
                <Grid
                  item
                  xl={boxRatio}
                  lg={boxRatio}
                  md={boxRatio}
                  sm={6}
                  xs={12}
                >
                  <Box
                    className="managerCard"
                    sx={{ cursor: "pointer", backgroundColor: "#F5F5F5" }}
                    onClick={props.handleAudited}
                    style={props.activeStyle.audited ? activeTileStyles : {}}
                  >
                    <img src="img/audited.svg" width="50" height="70" />
                    <Typography variant="h5">
                      {props.dashboardTasklist["AuditCompleted"]}{" "}
                    </Typography>
                    <Typography
                      variant="h6"
                      style={{ fontSize: "14px" }}
                      sx={{
                        color: "#FB4E0B",
                        textTransform: "uppercase",
                      }}
                    >
                      Audited
                    </Typography>
                  </Box>
                  {/* 
                  {props.activeStyle.audited ? (
                    <img
                      src="img/polygon.svg"
                      width="50"
                      height="70"
                      style={{
                        alignContent: "center",
                        width: "100%",
                        padding: 20,
                      }}
                    />
                  ) : (
                    ""
                  )} */}
                </Grid>
                {info.MD_RESPONSE && (
                  <Grid
                    item
                    xl={boxRatio}
                    lg={boxRatio}
                    md={boxRatio}
                    sm={6}
                    xs={12}
                  >
                    <Box
                      className="managerCard"
                      sx={{ cursor: "pointer", backgroundColor: "#F5F5F5" }}
                      onClick={props.handleMdResponse}
                      style={
                        props.activeStyle.mdresponse ? activeTileStyles : {}
                      }
                    >
                      <img src="img/completed.svg" width="50" height="70" />
                      <Typography variant="h5">{"0"}</Typography>
                      <Typography
                        variant="h6"
                        style={{ fontSize: "14px" }}
                        sx={{
                          color: "#FB4E0B",
                          textTransform: "uppercase",
                        }}
                      >
                        MD Reviewed
                      </Typography>
                    </Box>
                    {/* {props.activeStyle.completed ? (
                    <img
                      src="img/polygon.svg"
                      width="50"
                      height="70"
                      style={{
                        alignContent: "center",
                        width: "100%",
                        padding: 20,
                      }}
                    />
                  ) : (
                    ""
                  )} */}
                  </Grid>
                )}
              </Grid>
            </Grid>
          ) : (
            ""
          )}
        </Grid>
      </Box>
    </>
  );
};
